import { Injectable, inject } from '@angular/core'
import { Filter, Interval, RestClientPaged } from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { environment, isUtilizationTuningEnabled } from '../../../../environments/environment'
import { WorkBatch, WorkBatchCommand, WorkBatchCommandResult } from './work-batch'
import { Observable } from 'rxjs'

export class WorkBatchFilter {
  public static readonly WORK_ORDER_KEY = 'workOrderId'

  public static workOrderId(workOrderId: string): Filter {
    return new Filter(this.WORK_ORDER_KEY, workOrderId)
  }
}

@Injectable({
  providedIn: 'root',
})
export class WorkBatchService extends RestClientPaged<WorkBatch, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/work-batches', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public sendCommand(cmd: WorkBatchCommand): Observable<WorkBatchCommandResult> {
    return this.http.post<WorkBatchCommandResult>(
      `${environment.apiPath}/work-batches/command`,
      cmd
    )
  }

  /**
   * For development purposes only
   */
  public abort(facility: string, scheduleInterval: Interval): Observable<unknown> {
    if (isUtilizationTuningEnabled()) {
      return this.http.delete(`${environment.apiPath}/work-batches/abort`, {
        params: {
          facility,
          scheduleInterval: scheduleInterval.toString(),
        },
      })
    } else {
      throw Error('Feature not enabled')
    }
  }
}
